/**
 * The fallback avatar (avatar-lowpoly/, a three.js page on :5666, started by `./start.sh --fallback`).
 * It reads its own cues from the backend (`/avatar/events`); here it is only framed. If the page is
 * not up, the station background shows through and the reason goes to the diagnostics.
 */
import { useEffect, useState } from 'react';
import { describeError, report } from '../core/diagnostics';

export const LOWPOLY_PORT = 5666;

export function LowpolyAvatar({ onLive }: { onLive?: (live: boolean) => void }) {
  const url = `${window.location.protocol}//${window.location.hostname}:${LOWPOLY_PORT}`;
  const [up, setUp] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(url, { mode: 'no-cors' })
      .then(() => {
        if (cancelled) return;
        setUp(true);
        onLive?.(true);
      })
      .catch((e) => report('warn', 'avatar', `low-poly avatar not reachable at ${url}: ${describeError(e)}`));
    return () => { cancelled = true; };
  }, [url, onLive]);

  if (!up) return null;
  return <iframe src={url} title="avatar" style={{ width: '100%', height: '100%', border: 0 }} />;
}
